module.exports = __webpack_public_path__ + "img/core-first-4.250449f8.png";